import React from 'react';
import { SkeletonLoading } from '@saleshandy/design-system';

const ProspectDetailActivitySkeleton: React.FC = () => (
  <div className="prospect-detail-activity-skeleton">
    <div className="activity-type-filter-skeleton">
      <SkeletonLoading width={16} height={16} />
      <SkeletonLoading width={69} height={14} />
    </div>
    <div className="activity-list-skeleton">
      <div className="activity-list-skeleton-rows">
        <SkeletonLoading width={54} height={14} />
        <div className="activity-list-skeleton-rows-bottom">
          <div className="activity-list-skeleton-rows-bottom-left">
            <SkeletonLoading width={32} height={32} circle />
            <SkeletonLoading width={257} height={18} />
          </div>
          <SkeletonLoading width={62} height={18} />
        </div>
      </div>
      {Array.from({ length: 3 }).map(() => (
        <div className="activity-list-skeleton-row">
          <div className="activity-list-skeleton-rows">
            <SkeletonLoading width={54} height={14} />
            <div className="activity-list-skeleton-rows-bottom">
              <div className="activity-list-skeleton-rows-bottom-left">
                <SkeletonLoading width={32} height={32} circle />
                <SkeletonLoading width={257} height={18} />
              </div>
              <SkeletonLoading width={62} height={18} />
            </div>
            <div className="activity-list-skeleton-rows-bottom">
              <div className="activity-list-skeleton-rows-bottom-left">
                <SkeletonLoading width={32} height={32} circle />
                <SkeletonLoading width={257} height={18} />
              </div>
              <SkeletonLoading width={62} height={18} />
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default ProspectDetailActivitySkeleton;
